/** Dados e helpers do mock “Vínculos de Peças” (Design Component). */

export const EQUIPS = [
  { id: 'e1', modelo: 'imageRUNNER 2630i', fab: 'Canon', serie: 'CNR-2630-8841', tec: 'Laser mono', qtde: 12, volume: '30 ppm' },
  { id: 'e2', modelo: 'LaserJet Ent M507dn', fab: 'HP', serie: 'HPM-507-2290', tec: 'Laser mono', qtde: 34, volume: '43 ppm' },
  { id: 'e3', modelo: 'VersaLink C7000', fab: 'Xerox', serie: 'XRX-C7000-1174', tec: 'Laser color', qtde: 8, volume: '35 ppm' },
  { id: 'e4', modelo: 'TASKalfa 3554ci', fab: 'Kyocera', serie: 'KYO-3554-6620', tec: 'Laser color', qtde: 19, volume: '35 ppm' },
  { id: 'e5', modelo: 'MP C3004ex', fab: 'Ricoh', serie: 'RIC-3004-4415', tec: 'Laser color', qtde: 5, volume: '30 ppm' },
  { id: 'e6', modelo: 'MFC-L8900CDW', fab: 'Brother', serie: 'BRO-8900-7702', tec: 'Laser color', qtde: 27, volume: '33 ppm' },
];

export const TEC1 = ['Peças originais', 'Peças compatíveis', 'Suprimentos'];
export const TEC2 = [
  'Toner P&B',
  'Toner Color',
  'Cilindro',
  'Fusor',
  'Belt',
  'Kit manutenção',
  'Revelador',
  'Rolo de tração',
];

function mkParts() {
  const fabs = ['Canon', 'HP', 'Xerox', 'Kyocera', 'Ricoh', 'Brother', 'Lexmark', 'Katun'];
  const base = [
    ['Toner P&B', 'Toner preto', 'pág.'],
    ['Toner Color', 'Toner ciano', 'pág.'],
    ['Toner Color', 'Toner magenta', 'pág.'],
    ['Toner Color', 'Toner amarelo', 'pág.'],
    ['Cilindro', 'Unidade de cilindro', 'pág.'],
    ['Fusor', 'Unidade fusora', 'pág.'],
    ['Belt', 'Belt de transferência', 'pág.'],
    ['Kit manutenção', 'Kit de manutenção', 'pág.'],
    ['Revelador', 'Unidade reveladora', 'pág.'],
    ['Rolo de tração', 'Rolo de tração de papel', 'pág.'],
  ];
  const out = [];
  let n = 0;
  for (let i = 0; i < 68; i++) {
    const b = base[i % base.length];
    const fab = fabs[(i * 3) % fabs.length];
    const tec1 =
      b[0] === 'Toner P&B' || b[0] === 'Toner Color'
        ? i % 3 === 0
          ? 'Suprimentos'
          : i % 3 === 1
            ? 'Peças originais'
            : 'Peças compatíveis'
        : i % 2 === 0
          ? 'Peças originais'
          : 'Peças compatíveis';
    const vidaN = [6000, 8500, 12000, 18000, 24000, 45000, 100000, 150000][i % 8];
    n++;
    out.push({
      id: 'p' + n,
      nome: b[1] + ' ' + fab.slice(0, 2).toUpperCase() + '-' + (1200 + i * 7),
      fab,
      tec1,
      tec2: b[0],
      pn: fab.slice(0, 3).toUpperCase() + '-' + (10000 + i * 137),
      ean: '78' + String(90000000000 + i * 7654321).slice(0, 11),
      vida: vidaN.toLocaleString('pt-BR') + ' ' + b[2],
    });
  }
  return out;
}

export const PARTS = mkParts();
export const BYID = {};
PARTS.forEach((p) => {
  BYID[p.id] = p;
});

export const STATUS = {
  total: {
    label: 'Total',
    color: 'oklch(0.5 0.13 155)',
    bg: 'oklch(0.955 0.04 155)',
    dot: 'oklch(0.55 0.13 155)',
    desc: 'Encaixe e firmware compatíveis, sem ressalvas.',
  },
  parcial: {
    label: 'Parcial',
    color: 'oklch(0.48 0.12 75)',
    bg: 'oklch(0.965 0.05 85)',
    dot: 'oklch(0.7 0.14 75)',
    desc: 'Funciona com limitação de rendimento ou recurso.',
  },
  adaptacao: {
    label: 'Requer adaptação',
    color: 'oklch(0.47 0.14 245)',
    bg: 'oklch(0.96 0.035 245)',
    dot: 'oklch(0.57 0.14 245)',
    desc: 'Precisa de intervenção técnica — descreva abaixo.',
  },
};

export function thumb(size, has, radius) {
  return {
    width: size,
    height: size,
    flex: 'none',
    borderRadius: radius || 7,
    cursor: 'pointer',
    border: '1px solid ' + (has ? 'oklch(0.86 0.03 288)' : 'oklch(0.91 0.006 285)'),
    backgroundImage: has
      ? 'linear-gradient(135deg, oklch(0.9 0.04 288), oklch(0.96 0.02 288))'
      : 'repeating-linear-gradient(135deg, oklch(0.955 0.004 285) 0 5px, oklch(0.985 0.003 285) 5px 10px)',
  };
}

export const INITIAL_LINKS = {
  e1: {
    p1: { status: 'total' },
    p11: { status: 'total' },
    p5: { status: 'parcial' },
    p6: {
      status: 'adaptacao',
      obs: 'Requer troca do suporte lateral e reset de contador via painel de serviço.',
    },
    p28: {},
  },
  e3: { p2: { status: 'total' }, p3: { status: 'total' }, p4: { status: 'parcial' } },
};

export const INITIAL_PHOTOS = { e1: true, p1: true, p5: true };
